import React from 'react';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import withWidth from '@material-ui/core/withWidth';

import TopBar from './TopBar/TopBar';
import Menu from '../Menu/Menu';

const Header = () => {
    return (
        <Grid
            container
            spacing={8}
            direction="row"
            justify="flex-start"
            alignItems="flex-start"
        >
            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
            >
                <Paper style={{ top: 0 }}>
                    <Hidden smDown>
                        <TopBar />
                    </Hidden>
                    <Menu />
                </Paper>
            </Grid>
        </Grid>
    );
};

export default withWidth()(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js